const ArtistActionTypes = {
  FETCH_ARTIST_ALBUMS_START: 'FETCH_ARTIST_ALBUMS_START',
  FETCH_ARTIST_ALBUMS_SUCCESS: 'FETCH_ARTIST_ALBUMS_SUCCESS',
  FETCH_ARTIST_ALBUMS_FAILURE: 'FETCH_ARTIST_ALBUMS_FAILURE',
  FETCH_ARTIST_TRACKS_START: 'FETCH_ARTIST_TRACKS_START',
  FETCH_ARTIST_TRACKS_SUCCESS: 'FETCH_ARTIST_TRACKS_SUCCESS',
  FETCH_ARTIST_TRACKS_FAILURE: 'FETCH_ARTIST_TRACKS_FAILURE',
  FETCH_ARTIST_RELATED_START: 'FETCH_ARTIST_RELATED_START',
  FETCH_ARTIST_RELATED_SUCCESS: 'FETCH_ARTIST_RELATED_SUCCESS',
  FETCH_ARTIST_RELATED_FAILURE: 'FETCH_ARTIST_RELATED_FAILURE',
  FETCH_ARTIST_START: 'FETCH_ARTIST_START',
  FETCH_ARTIST_SUCCESS: 'FETCH_ARTIST_SUCCESS',
  FETCH_ARTIST_FAILURE: 'FETCH_ARTIST_FAILURE',
  RESET_ARTIST: 'RESET_ARTIST'
};

export default ArtistActionTypes;
